import { render, staticRenderFns } from "./LoanAmountInput.vue?vue&type=template&id=387c4642&scoped=true"
import script from "./LoanAmountInput.vue?vue&type=script&lang=js"
export * from "./LoanAmountInput.vue?vue&type=script&lang=js"
import style0 from "./LoanAmountInput.vue?vue&type=style&index=0&id=387c4642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c4642",
  null
  
)

export default component.exports